import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon CustomerSupportAccountIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const CustomerSupportAccountIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 24 24">
      <path
        d="M3.36562 9.63991C3.36562 9.63991 3.04439 4.11498 8.73019 1.73892C14.4165 -0.637594 21.305 3.32433 20.8059 9.63991C19.7556 10.4297 19.6579 11.8515 19.7556 13.1882C19.6479 14.3441 20.5024 15.2703 20.2525 15.2426C19.617 18.7002 18.3902 20.9651 13.8995 21.1634C13.6574 21.1746 13.1172 21.1778 12.6944 21.1634"
        stroke="#503291"
        strokeLinecap="round"
      />
      <path
        d="M20.9229 9.38013C21.5477 9.38016 22.1549 9.72427 22.623 10.3069C23.0907 10.8891 23.3788 11.6643 23.3789 12.4163C23.3789 13.9439 22.2237 15.2082 20.9229 15.2083C20.2447 15.2083 19.7574 14.9616 19.4258 14.5325C19.0804 14.0856 18.8623 13.3847 18.8623 12.4163C18.8623 11.0706 19.0932 10.3309 19.4189 9.92798C19.7207 9.55485 20.1812 9.38013 20.9229 9.38013Z"
        stroke="#503291"
      />
      <path
        d="M9.65991 20.3801H11.5466C12.1205 20.3801 12.5857 20.8454 12.5857 21.4192C12.5857 21.993 12.1205 22.4583 11.5466 22.4583H9.65991C9.08609 22.4583 8.62087 21.993 8.62085 21.4192C8.62085 20.8813 9.02959 20.4383 9.55347 20.385L9.65991 20.3801Z"
        stroke="#503291"
      />
      <path
        d="M3.35913 10.5C3.73486 10.5 3.9595 10.5804 4.10034 10.6768C4.2389 10.7717 4.34452 10.9154 4.42261 11.1318C4.59368 11.6063 4.58569 12.2671 4.58569 13.0781C4.58569 13.8892 4.59373 14.55 4.42261 15.0244C4.34452 15.2409 4.2389 15.3846 4.10034 15.4795C3.9595 15.5758 3.7348 15.6562 3.35913 15.6562C1.8228 15.6562 0.620894 14.4783 0.62085 13.0781C0.62085 11.6779 1.82277 10.5 3.35913 10.5Z"
        stroke="#503291"
      />
    </Icon>
  )
}
export default CustomerSupportAccountIcon
